import { Alert, Box, Snackbar } from '@mui/material';
import React from 'react';

import useAlert from '../../hooks/useAlert';

export default function AlertPopup(): React.JSX.Element {
  const { alert, open, clearAlert } = useAlert();

  return (
    <Box sx={{ marginBottom: '5rem' }}>
      <Snackbar
        open={open}
        onClose={clearAlert}
        sx={{ marginBottom: '1rem', width: '100%' }}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        autoHideDuration={alert.duration}
      >
        <Alert
          severity={alert.severity || 'error'}
          onClose={alert.dismissible ? clearAlert : undefined}
          sx={{
            position: 'absolute',
            zIndex: 10,
          }}
        >
          {alert.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}
